export default __webpack_public_path__ + "static/media/Groups.10c6ff58.svg";